import { useState } from "react";
import { Check, ShoppingCart } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useCommerce } from "@/contexts/CommerceContext";


const CheckoutButton = ({ product, className = "", compact = false, testId }) => {
  const [loading, setLoading] = useState(false);
  const {
    account,
    accountLoading,
    startFiveM,
    startDiscord,
    addToCart,
    isInCart,
  } = useCommerce();
  const isConnected = Number.isInteger(product.tebex_package_id) && product.tebex_package_id > 0;
  const inCart = isInCart(product.id);

  const handleAddToCart = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!isConnected || loading || accountLoading) return;
    if (inCart) {
      toast.info("This product is already in your basket.");
      return;
    }

    setLoading(true);
    try {
      const returnPath = `${window.location.pathname}${window.location.search}`;
      if (!account.fivem_connected) {
        toast.info("Connect FiveM first. You will return to this page afterwards.");
        await startFiveM(returnPath);
        return;
      }
      if (!account.discord_connected) {
        toast.info("Now connect Discord. You will return to this page afterwards.");
        await startDiscord(returnPath);
        return;
      }
      if (addToCart(product.id)) {
        toast.success(`${product.name} added to your basket.`);
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Account connection could not be started. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const buttonLabel = !isConnected
    ? "Coming soon"
    : inCart
      ? "In basket"
      : loading
        ? "Opening…"
        : "Add to basket";

  return (
    <Button
      type="button"
      onClick={handleAddToCart}
      disabled={!isConnected || loading || accountLoading}
      title={isConnected ? "Add this product to your basket" : "Tebex package connection pending"}
      className={className}
      data-testid={testId || `product-buy-btn-${product.id}`}
    >
      {inCart ? (
        <Check className={`${compact ? "h-4 w-4" : "h-5 w-5"} mr-2`} />
      ) : (
        <ShoppingCart className={`${compact ? "h-4 w-4" : "h-5 w-5"} mr-2`} />
      )}
      {buttonLabel}
    </Button>
  );
};

export default CheckoutButton;
